import { useState } from "react";
import { Modal, Button, Checkbox } from "flowbite-react";
import TextInput from "../components/TextInput";
import CompanySelector from "../components/CompanySelector";
import Select from "../components/Select";
import ApiKeysModal from "../components/ApiKeysModal";

export default function UserEditModal({ user, onClose, onSave, error }) {
  const [formData, setFormData] = useState(
    user || {
      name: "",
      email: "",
      company: "",
      role: "user",
      active: false,
      lastLogin: new Date().toISOString().substring(0, 16),
    },
  );

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <div className="container z-50">
      <Modal
        show={true}
        onClose={() => {
          onClose();
        }}
      >
        <Modal.Header>{user ? "Edit User" : "Add New User"}</Modal.Header>
        <Modal.Body className="items-center justify-center space-y-6 dark:text-white">
          <TextInput
            label={"Name"}
            value={formData.name}
            onChange={handleChange}
          />
          <TextInput
            label={"Email"}
            value={formData.email}
            onChange={handleChange}
            type="email"
          />
          <label
            htmlFor="company"
            className="mb-2 mr-6 inline text-sm font-medium text-gray-900 dark:text-white"
          >
            Select a company
          </label>
          <CompanySelector
            id="company"
            company={formData.company}
            setSelectedCompany={(company) =>
              setFormData({ ...formData, company })
            }
          />
          <Select
            options={[
              { label: "User", value: "USER" },
              { label: "Admin", value: "ADMIN" },
            ]}
            label={"Role"}
            setValue={(role) => setFormData({ ...formData, role })}
            value={formData.role}
          />
          {user && (
            <div className="flex align-middle">
              <label
                htmlFor="active"
                className="mb-2 mr-6 inline text-sm font-medium text-gray-900 dark:text-white"
              >
                Active
              </label>
              <Checkbox
                id="active"
                onChange={handleChange}
                color={"blue"}
                size={"large"}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex w-full justify-end space-x-3">
            <div className="mr-auto">
              <p
                id="helper-text-explanation"
                class="mt-2	 text-center text-sm text-red-500"
              >
                {error}
              </p>
            </div>
            <Button onClick={onClose} color={"light"}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} color={"blue"}>
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
